import { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./LocalBackground.css";
import savesUnderline from '../../assets/figma_saves_underline.svg';
import iconSun from '../../assets/sun_icon.svg';
import iconHome from '../../assets/home_icon.svg';
import iconBattery from '../../assets/battery_icon.svg';

const cards = [
  {
    icon: iconSun,
    label: "Our Mission",
    heading: <>Helping Australian <Link to="/residential-solutions" className="mvp-card-link">households</Link> take control of their energy future.</>,
    points: ["Lower energy costs", "Greater energy independence", "More control over home energy"],
  },
  {
    icon: iconHome,
    label: "Our Vision",
    heading: "Helping homeowners make confident energy decisions.",
    points: ["Honest advice", "Trusted products", "Tailored solutions"],
  },
  {
    icon: iconBattery,
    label: "Our Purpose",
    heading: "To be the energy partner homeowners can rely on for years to come.",
    points: ["Long-term customer support", "Help when it matters most", "A team that's here to stay"],
  },
];

export default function LocalBackground() {
  const sectionRef = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(([e]) => setInView(e.isIntersecting), { threshold: 0.1 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className={`mvp-section ${inView ? "mvp-in-view" : ""}`}>
      <div className="mvp-inner">

        {/* Header */}
        <div className="mvp-header">
          <h2 className="mvp-title">
            More than installers —<br />
            <span className="mvp-title-accent">
              your long-term energy partner
              <img src={savesUnderline} alt="" className="mvp-stroke" />
            </span>
          </h2>
        </div>

        {/* Cards */}
        <div className="mvp-grid">
          {cards.map((card, i) => (
            <div className="mvp-card" key={i}>
              <div className="mvp-card-top">
                <h3 className="mvp-card-label">{card.label}</h3>
                <img src={card.icon} alt="" className="mvp-card-icon" />
              </div>
              <div className="mvp-card-bar" />
              <p className="mvp-card-heading">{card.heading}</p>
              <ul className="mvp-list">
                {card.points.map((pt, j) => (
                  <li key={j}>
                    <span className="mvp-check-icon">
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                        <path d="M20.396 11c-.018-.646-.215-1.275-.57-1.816-.354-.54-.852-.972-1.438-1.246.223-.607.27-1.264.14-1.897-.131-.634-.437-1.218-.882-1.687-.47-.445-1.053-.75-1.687-.882-.633-.13-1.29-.083-1.897.14-.273-.587-.704-1.086-1.245-1.44S11.647 1.62 11 1.604c-.646.017-1.273.213-1.813.568s-.969.854-1.24 1.44c-.608-.223-1.267-.272-1.902-.14-.635.13-1.22.436-1.69.882-.445.47-.749 1.055-.878 1.688-.13.633-.08 1.29.144 1.896-.587.274-1.087.705-1.443 1.245-.356.54-.555 1.17-.574 1.817.02.648.218 1.28.574 1.82.356.54.856.972 1.443 1.245-.224.606-.274 1.263-.144 1.896.13.634.433 1.218.877 1.688.47.443 1.054.747 1.687.878.633.132 1.29.084 1.897-.136.274.586.705 1.084 1.246 1.439.54.354 1.17.551 1.816.569.647-.016 1.276-.213 1.817-.567s.972-.854 1.245-1.44c.604.239 1.266.296 1.903.164.636-.132 1.22-.447 1.68-.907.46-.46.776-1.044.908-1.681s.075-1.299-.165-1.903c.586-.274 1.084-.705 1.439-1.246.354-.54.551-1.17.569-1.816zM9.662 14.85l-3.429-3.428 1.293-1.302 2.072 2.072 4.4-4.794 1.347 1.246z" fill="#3b82f6"/>
                      </svg>
                    </span>
                    {pt}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
